<template>
	<div class="panel_shouyin">
		<div class="tabBox">
			<div class="tabList">
				<div class="tabItem" :class="[curTabIndex===0?'active':'']" @click="changeTabIndex(0)">
					今日订单
					<span class="num">{{jiedaiLength.order}}</span>
				</div>
				<div class="tabItem" :class="[curTabIndex===1?'active':'']" @click="changeTabIndex(1)">
					门诊宠物
					<span class="num">{{jiedaiLength.guahao}}</span>
				</div>
				<div class="tabItem" :class="[curTabIndex===2?'active':'']" @click="changeTabIndex(2)">
					洗美宠物
					<span class="num">{{jiedaiLength.ximei}}</span>
				</div>
				<div class="tabItem" :class="[curTabIndex===3?'active':'']" @click="changeTabIndex(3)">
					寄养宠物
					<span class="num">{{jiedaiLength.jiyang}}</span>
				</div>
				<div class="tabItem" :class="[curTabIndex===4?'active':'']" @click="changeTabIndex(4)">
					住院宠物
					<span class="num">{{jiedaiLength.zhuyuan}}</span>
				</div>
				<div class="tabItem" :class="[curTabIndex===5?'active':'']" @click="changeTabIndex(5)">
					免疫宠物
					<span class="num">{{jiedaiLength.YMQC}}</span>
				</div>
			</div>
		</div>
		<div style="width:100%;height: 100%;">
			<jiedaiOrder v-if="curTabIndex===0"></jiedaiOrder>
			<jiedaiGuahao v-if="curTabIndex===1"></jiedaiGuahao>
			<jiedaiXimei v-if="curTabIndex===2"></jiedaiXimei>
			<jiedaiJiyang v-if="curTabIndex===3"></jiedaiJiyang>
			<jiedaiZhuyuan v-if="curTabIndex===4"></jiedaiZhuyuan>
			<jiedaiYMQC v-if="curTabIndex===5"></jiedaiYMQC>
		</div>
	</div>
</template>
<script>
	import jiedaiOrder from "./jiedai/jiedaiOrder.vue"
	import jiedaiGuahao from "./jiedai/jiedaiGuahao.vue"
	import jiedaiXimei from "./jiedai/jiedaiXimei.vue"
	import jiedaiJiyang from "./jiedai/jiedaiJiyang.vue"
	import jiedaiZhuyuan from "./jiedai/jiedaiZhuyuan.vue"
	import jiedaiYMQC from "./jiedai/jiedaiYMQC.vue"
	export default {
		components:{jiedaiOrder,jiedaiGuahao,jiedaiXimei,jiedaiJiyang,jiedaiZhuyuan,jiedaiYMQC},
		data(){
			return{
				curTabIndex:0,
				// jiedaiList
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
			jiedaiLength(){
				return this.$store.state.mendian.jiedaiLength;
			},
		},
		mounted(){
			// setInterval(()=>{
				
			// },1000)
			this.curTabIndex = Number(sessionStorage.getItem('jiedaiIndex'))||0
		},
		methods: {
			// 改变tab
			changeTabIndex(index){
				this.curTabIndex = index;
				sessionStorage.setItem('jiedaiIndex',index)
			},
			
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	background-color: #fff;height: 100%;padding:65px 0 0;box-sizing: border-box;overflow: hidden;position: relative;
	.tabBox{
		width:100%;position: absolute;top:0;z-index: 1;background-color: #fff;
		.tabList{
			margin:0px 15px 0px 15px;border-bottom:1px solid #dbdbdb;display: flex;height: 60px;box-sizing: border-box;
			.tabItem{
				position: relative;margin:0 32px;padding:20px 0 15px 0;border-bottom:3px solid transparent;color:#757575;font-size: 14px;cursor: pointer;line-height: 20px;
				&.active{
					border-color:$mainColor;color:$fontColor;
				}
				// .num{
				// 	display: inline-block;width:20px;height: 20px;background:#ff4d4f;border-radius: 50%;line-height: 20px;font-size: 12px;color:#fff;text-align: center;vertical-align: text-bottom;position: absolute;top: 20px;right:-22px;
				// }
				.num{
					font-size: 12px;color:#FE2D2D;font-weight: bold;
				}
			}
		}
	}
	.table{
		
	}
	.pageBox{
		position: absolute;bottom:0;width:100%;z-index: 1;padding:0 0 20px 0;background-color: #fff;
	}
}
</style>
